export { getScrollParent } from './getScrollParent';
